import React, {useContext, useState, useEffect} from "react";
import { AppContext } from '../../App'

//Import Css
import './developScreenCompt.css'

//Import Component
import {InfoDevelopComponent} from './../home/infoDevelopComponent/infoDevelopComponent'






export function DevelopScreenCompt({comptInfo, photoInfoScreen}) {

    // const [] = useContext(AppContext)




    return(

        <div className="container-all-dv-screen-compt">

            <div className="box-blk-A-inf-screen-compt">{comptInfo}</div>

            <div className="box-blk-B-inf-screen-compt">
                <img className="photo-screen-compt" src={photoInfoScreen}/>
            </div>


        </div>


    );
}